import { lazy, Suspense } from 'react';
import LeftSideBarToggle from './components/LeftSideBarToggle';
import ProfileDropdown from './components/ProfileDropdown';
// import SearchBox from './components/SearchBox';
import GoldTradingKillSwitch from './components/GoldTradingKillSwitch';
import SafegoldWalletBalance from './components/SafegoldWalletBalance';
import BankBalance from './components/BankBalance';
import ThemeModeToggle from './components/ThemeModeToggle';
import WhatsAppNavButton from './components/WhatsAppNavButton';

const Notifications = lazy(() => import('./components/Notifications'));

const TopNavigationBar = () => (
  <header className="topbar">
    <div className="container-xxl">
      <div className="navbar-header">
        <div className="d-flex align-items-center gap-2">
          <LeftSideBarToggle />
          {/* <SearchBox /> */}
        </div>
        <div className="d-flex align-items-center gap-1">
          <BankBalance />
          <SafegoldWalletBalance />
          <GoldTradingKillSwitch />
          <WhatsAppNavButton />
          <ThemeModeToggle />
          <Suspense fallback={null}>
            <Notifications />
          </Suspense>
          <ProfileDropdown />
        </div>
      </div>
    </div>
  </header>
);

export default TopNavigationBar;
